import EventActionProto from '../event-action-proto';

export default class EventProjectTemplateResetByCompany extends EventActionProto {

    constructor(rawEvent) {
        super(rawEvent.uid, rawEvent.data, rawEvent.companyId);
    }

    process() {
        // gd.session.templatesList.reset(this.data.projects ? this.data.projects.filter(m=>m.isTemplate && !m.parentId) : [], {parse:true});
        gd.session.templatesList.resetAndKeepOldModels(this.data);

    }
};